"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setJumpToDate = exports.setFilterBy = exports.setSelectedSlot = exports.setApptTimeMachine = exports.updateAppointment = exports.setReasonMachine = exports.setProvider = exports.setLoadingMachine = exports.setKeepAppointment = exports.setCapabilities = exports.setAppointmentQuery = exports.setAppointment = void 0;
const xstate_1 = require("xstate");
const loadingMachine_1 = require("./loaderMachine/loadingMachine");
const reasonMachine_1 = require("./reasonMachine/reasonMachine");
const apptTIme_1 = require("./apptTime/apptTIme");
const setLoadingMachine = '@action/CREATE_LOADING_MACHINE';
exports.setLoadingMachine = setLoadingMachine;
const setAppointment = '@action/SET_APPOINTMENT';
exports.setAppointment = setAppointment;
const updateAppointment = '@action/UPDATE_APPOINTMENT';
exports.updateAppointment = updateAppointment;
const setProvider = '@action/SET_PROVIDER';
exports.setProvider = setProvider;
const setCapabilities = '@action/SET_CAPABILITIES';
exports.setCapabilities = setCapabilities;
const setAppointmentQuery = '@action/SET_APPOINTMENT_QUERY';
exports.setAppointmentQuery = setAppointmentQuery;
const setReasonMachine = '@action/SET_REASON_MACHINE';
exports.setReasonMachine = setReasonMachine;
const setKeepAppointment = '@action/SET_KEEP_APPOINTMENT';
exports.setKeepAppointment = setKeepAppointment;
const setApptTimeMachine = '@action/SET_APPT_TIME_MACHINE';
exports.setApptTimeMachine = setApptTimeMachine;
const setSelectedSlot = '@action/SET_SELECTED_SLOT';
exports.setSelectedSlot = setSelectedSlot;
const setFilterBy = '@action/SET_FILTER_BY';
exports.setFilterBy = setFilterBy;
const setJumpToDate = '@action/SET_JUMP_TO_DATE';
exports.setJumpToDate = setJumpToDate;
const actions = {
    [setLoadingMachine]: (0, xstate_1.assign)((context) => {
        return {
            loadingMachine: (0, xstate_1.spawn)((0, loadingMachine_1.createLoadingMachine)({
                appointmentId: context.appointmentId,
                services: {
                    getAppointment: context.services.getAppointment,
                    getProvider: context.services.getProvider
                },
                appointment: context === null || context === void 0 ? void 0 : context.appointment,
                provider: context === null || context === void 0 ? void 0 : context.provider,
                capabilities: context === null || context === void 0 ? void 0 : context.capabilities
            }))
        };
    }),
    [setApptTimeMachine]: (0, xstate_1.assign)((context) => {
        var _a, _b, _c;
        if (!context.appointment || !context.provider) {
            throw new Error('Appointment and provider must be set before setting reason machine');
        }
        return {
            apptTimeMachine: (0, xstate_1.spawn)((0, apptTIme_1.createApptTimeMachine)({
                provider: context.provider,
                location: context.appointment.location,
                appointmentQuery: Object.assign(Object.assign({}, context.appointmentQuery), { periodStart: (_a = context.jumpedToDate) !== null && _a !== void 0 ? _a : context.appointmentQuery.periodStart }),
                periodStart: (_b = context.jumpedToDate) !== null && _b !== void 0 ? _b : context.appointmentQuery.periodStart,
                customerCode: (_c = context.customerCode) !== null && _c !== void 0 ? _c : '',
                services: context.services,
                visibility: context.visibility,
                isInitialDataLoadFromPreviousStep: false,
                availableSlots: [],
                query: {},
                filterBy: context.filterBy,
                jumpedToDate: context.jumpedToDate,
                productName: context.productName,
                apiBaseURL: context.apiBaseURL
            }))
        };
    }),
    [setReasonMachine]: (0, xstate_1.assign)((context) => {
        if (!context.appointment || !context.provider || !context.selectedSlot) {
            throw new Error('Appointment and provider must be set before setting reason machine');
        }
        return {
            reasonMachine: (0, xstate_1.spawn)((0, reasonMachine_1.createReasonMachine)({
                services: {
                    getRescheduleReasons: context.services.getRescheduleReasons,
                    rescheduleAppointment: context.services.rescheduleAppointment
                },
                appointment: context.appointment,
                provider: context.provider,
                selectedSlot: context.selectedSlot,
                rescheduleReasons: [],
                selectedRescheduleReason: null
            }))
        };
    }),
    [setSelectedSlot]: (0, xstate_1.assign)((context, event) => {
        return {
            selectedSlot: event.context.selectedSlot,
            appointmentQuery: Object.assign(Object.assign({}, context.appointmentQuery), { periodStart: event.context.periodStart })
        };
    }),
    [setAppointmentQuery]: (0, xstate_1.assign)({
        appointmentQuery: (_context, ev) => {
            return {
                patientRel: ev.context.appointment.patient_relationship,
                locationIds: [
                    ev.context.appointment.location.location_pma_id ||
                        ev.context.appointment.location.location_ehr_id
                ],
                purpose: {
                    name: ev.context.appointment.purpose_name,
                    visit_method: ev.context.appointment.visit_method
                }
            };
        }
    }),
    [setAppointment]: (0, xstate_1.assign)((_, event) => {
        return { appointment: event.context.appointment };
    }),
    [updateAppointment]: (0, xstate_1.assign)((context, event) => {
        return {
            appointment: Object.assign(Object.assign({}, context.appointment), event.context.appointment)
        };
    }),
    [setCapabilities]: (0, xstate_1.assign)((_, event) => {
        return { capabilities: event.context.capabilities };
    }),
    [setProvider]: (0, xstate_1.assign)((_, event) => {
        return { provider: event.context.provider };
    }),
    [setKeepAppointment]: (0, xstate_1.assign)((_, event) => {
        return { keptOriginalAppointment: event.context.keepOriginalAppointment };
    }),
    [setFilterBy]: (0, xstate_1.assign)((_, event) => {
        return {
            filterBy: event.context.filterBy,
            jumpedToDate: event.context.jumpedToDate
        };
    }),
    [setJumpToDate]: (0, xstate_1.assign)((_context, event) => {
        return {
            jumpedToDate: event.context.jumpedToDate
        };
    })
};
exports.default = actions;
//# sourceMappingURL=actions.main.js.map